import { render } from "./ControlPanelInboxEmail.vue?vue&type=template&id=05b8a24c&scoped=true"
import script from "./ControlPanelInboxEmail.vue?vue&type=script&lang=js"
export * from "./ControlPanelInboxEmail.vue?vue&type=script&lang=js"

import "./ControlPanelInboxEmail.vue?vue&type=style&index=0&id=05b8a24c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b8a24c"]])

export default __exports__